(function () {
    'use strict';

    var module = angular.module('uwAgenda.agenda');
    // service for handling agenda-day data
    module.factory('AgendaDay', ['$rootScope', 'DayStartEndTime', 'AgendaDayPart', 'DateService', AgendaDayFn]);

    function AgendaDayFn($rootScope, DayStartEndTime, AgendaDayPart, DateService) {

        var AgendaDay = function () {

            // day specific data
            var data = {
                sharedAgenda: {}, // the agenda to show                
                date: null, // current selected date
                dateCaption: '', // current selected date for frontend
                description: '', // descripton text of agenda items // todo-alex ev noch überdenken
                appointmentsCount: 0,
                hightlightedAppointmentsCount: 0,
                parts: {
                    // day parts (times)
                },
                noAppointments: false // show no_appointments info
            };


            // clear
            function clear() {
                if (data.parts.morning) { data.parts.morning.clear(); }
                if (data.parts.afternoon) { data.parts.afternoon.clear(); }
                if (data.parts.evening) { data.parts.evening.clear(); }
                data.appointmentsCount = 0;
                data.hightlightedAppointmentsCount = 0;
                data.noAppointments = false;
            }

            // create date parts
            function createParts() {
                // if ringfoon -> no day-parts at all
                var useDayParts = false;
                // else check
                if (!$rootScope.isRingfoon) {
                    useDayParts = data.sharedAgenda.useDayParts;
                    // only use day parts if selected date is today !!!
                    if (!DateService.isToday()) {
                        useDayParts = false;
                    } // if
                } // if
                data.parts.morning = new AgendaDayPart('morning', DayStartEndTime.Start.hour, 12, useDayParts);
                data.parts.afternoon = new AgendaDayPart('afternoon', 12, 18, useDayParts);
                data.parts.evening = new AgendaDayPart('evening', 18, 24, useDayParts);
            }

            // init service
            function init(times) {
                // create parts
                createParts();

                // split into day-parts
                split(times);
            }

            // split into day parts
            function split(times) {
                var i = 0;
                var len = times.length;
                if (len === 0) { data.noAppointments = true; }
                // iterate
                for (i = 0; i < len; i++) {
                    var time = times[i];
                    
                    // counting ...
                    if (time.isAppointment) {
                        data.appointmentsCount++;
                        // is new -> unknown patient ?
                        if (time.highlight) {
                            data.hightlightedAppointmentsCount++;                            
                        } //if
                    } // if                   


                    if (time.hour >= DayStartEndTime.Start.hour && time.hour < 12) {
                        // moring from 06:00 - > 11:45
                        data.parts.morning.data.times.push(time);
                        if (time.isAppointment) {
                            data.parts.morning.data.appointmentsCount++;
                        } // if
                    } //if
                    else if (time.hour >= 12 && time.hour < 18) {
                        // afternoon from 12 to 18
                        data.parts.afternoon.data.times.push(time);
                        if (time.isAppointment) {
                            data.parts.afternoon.data.appointmentsCount++;
                        } // if
                    } // else if
                    else {
                        // evening from 18 to 24
                        data.parts.evening.data.times.push(time);
                        if (time.isAppointment) {
                            data.parts.evening.data.appointmentsCount++;
                        } // if
                    } //else

                } // for

                times = null;

            } // split

            // collapse
            function collapse(collapsed) {
                data.parts.morning.collapse(collapsed);
                data.parts.afternoon.collapse(collapsed);
                data.parts.evening.collapse(collapsed);
            } // collapse

            // public
            this.init = init;
            this.data = data;
            this.clear = clear;
            this.collapse = collapse;

        };



        return AgendaDay;
    }
})();